export var FIRM_CALCULATOR_VERSION;
(function (FIRM_CALCULATOR_VERSION) {
    FIRM_CALCULATOR_VERSION["V1"] = "1.0";
    FIRM_CALCULATOR_VERSION["V2"] = "2.0";
})(FIRM_CALCULATOR_VERSION || (FIRM_CALCULATOR_VERSION = {}));
export var LATEST_FIRM_CALCULATOR_VERSION = FIRM_CALCULATOR_VERSION.V2;
//# sourceMappingURL=index.js.map